var $3108f34a285e911e$exports = {};
$3108f34a285e911e$exports = {
    "maximum": `\u{41C}\u{430}\u{43A}\u{441}\u{438}\u{43C}\u{443}\u{43C}`,
    "minimum": `\u{41C}\u{456}\u{43D}\u{456}\u{43C}\u{443}\u{43C}`
};


export {$3108f34a285e911e$exports as default};
//# sourceMappingURL=uk-UA.module.js.map
